import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { DemandsRequester, Requesters } from 'src/app/models/Requester'
import { NotificationService } from 'src/app/services/notification.service'
import { UserService } from 'src/app/services/user.service'

@Component({
	selector: 'app-requester',
	templateUrl: './requester.component.html'
})
export class RequesterComponent implements OnInit {

		@Input() public requester: Requesters
		@Output() public close: EventEmitter<any> = new EventEmitter()

		public demands: Array<DemandsRequester> = []

		public carouselPageNow: number = 1
	public carouselItens: number = 0
	public carouselPages: number = 0
	public mediaUrlSelected: string = ''

		public arrowLeftEnable: boolean = false
	public arrowRightEnable: boolean = true
	public photoFromCarouselEnable: boolean = false
	public showButtonMoreDemands: boolean = true

	public skipDemands: number = 0

		constructor(
		private readonly notificationService: NotificationService,
		private readonly userService: UserService
		) {}

		public ngOnInit(): void {
				this.getDemands()
		}

		public async getDemands() {
				this.notificationService.initLoading()

		  const responseRequestDemands =
						await this.userService.getDemandsForRequester(this.requester.idMongo, this.skipDemands).toPromise()

		  this.demands = [...this.demands, ...responseRequestDemands.content]

		  this.showButtonMoreDemands = !Boolean(
			this.demands.length >= responseRequestDemands.numberOfDemands
		)
				this.notificationService.stopLoading()
		}

		public openDetailsDemand(index: number) {
				this.closeAllDetailsDemand()

				this.demands[index].open = true

				this.carouselItens = this.demands[index].images.length

				this.setCarouselPages(this.carouselItens)
		}

		public closeDetailsDemand(index: number) {
				this.demands[index].open = false
		}

		public closeAllDetailsDemand() {
				this.demands.forEach(demand => {
						demand.open = false
				})
		}

		public setCarouselPages(itens: number) {
		this.carouselPages = Math.ceil(itens / 4)
	}

		public moveCarousel(direction: 'left' | 'right') {
		const carousel = document.getElementById('carousel-content') as HTMLDivElement
		const carouselWidth: number = 1270

		if (direction == 'left') {
			if (this.carouselPageNow > 1) {
				this.carouselPageNow--
			}
		}
		if (direction == 'right') {
			if (this.carouselPageNow < this.carouselPages) {
				this.carouselPageNow++
			}
		}

		if (this.carouselPageNow > 1) {
			this.arrowLeftEnable = true
		} else {
			this.arrowLeftEnable = false
		}

		if (this.carouselPageNow == this.carouselPages) {
			this.arrowRightEnable = false
		} else {
			this.arrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carouselPageNow - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

		public openClosePhotoFromCarousel(media?: string) {
		if (media) {
			this.photoFromCarouselEnable = true
			this.mediaUrlSelected = media
		} else {
			this.photoFromCarouselEnable = false
			removeToolTip()
		}
	}

		public closeRequester() {
				this.close.emit()
		}

	public getMoreDemands() {
		this.skipDemands = this.skipDemands + 10

		this.getDemands()
	}
}
